var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
import * as R from 'ramda';
export var getExternalResources = function getExternalResources(structure) {
  return R.pipe(R.pathOr([], ['data', 'dataflows', 0, 'annotations']), R.reduce(function (acc, annotation) {
    if (R.pipe(R.prop('type'), R.complement(R.equals)('EXT_RESOURCE'))(annotation)) {
      return acc;
    }
    var split = R.pipe(R.prop('text'), R.when(R.isNil, R.always('')), R.split('|'))(annotation);
    if (R.length(split) < 2) {
      return acc;
    }
    var parse = R.pipe(R.take(3), function (_ref) {
      var label = _ref[0],
        link = _ref[1],
        img = _ref[2];
      return {
        label: label,
        link: link,
        img: img
      };
    })(split);
    return R.append(_extends({
      id: 'EXT_RESOURCE_' + R.length(acc)
    }, parse), acc);
  }, []))(structure);
};